import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { SingleCard } from './layouts';
import { LoginForm } from './components';

export const UnauthenticatedContent = () => {
  return (
    <Routes>
      <Route
        path='/login'
        element={
          <SingleCard title='Sign In'>
            <LoginForm />
          </SingleCard>
        }
      />
      <Route path='*' element={<Navigate to='/login' />} />
    </Routes>
  );
};
